/**
 * Whether a facility offers Bar & Park at all (`services.bar_park.available`). Distinct
 * from `bar_park_open`, which is whether it is open for check-ins right now. Franchise
 * facilities mostly have no Bar & Park, so every Bar & Park surface in admin hides
 * behind this.
 *
 * @param {object|null|undefined} facility
 * @returns {boolean}
 */
export const facilityOffersBarPark = (facility) => Boolean(facility?.services?.bar_park?.available)
